module.exports = __webpack_public_path__ + "static/media/04-usa.fc10cd01.png";